<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <v-expansion-panels flat popout hover>
              <v-expansion-panel
              >
                <v-expansion-panel-header class="bg-light">
                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="salespersonCode"
                            label="Plasiyer Kodu"
                            filled
                            solo
                            dense
                            clearable
                        ></v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="salespersonName"
                            label="Plasiyer Adı"
                            filled
                            solo
                            dense
                            clearable
                        ></v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeStart)"
                                label="Tarih Aralık Başlangıç"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeStart = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeStart"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeEnd)"
                                label="Tarih Aralık Bitiş"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeEnd = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeEnd"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-12 text-end">
                        <v-btn
                            color="primary darken-1"
                            small
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Filtrele
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div>
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10 </v-btn>
                <v-btn @click="perPage = 20"> 20 </v-btn>
                <v-btn @click="perPage = 30"> 30 </v-btn>
                <v-btn @click="perPage = 50"> 50 </v-btn>
              </v-btn-toggle>
            </div>
            <div class="ms-auto">
              <v-btn v-if="this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1'" small color="success darken-1" @click="openNewTargetDialog">Hedef Oluştur</v-btn>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="text-start">Toplam <b></b> Kayıt Bulundu</p>
          <ResultsTableView :perPage="perPage"></ResultsTableView>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="1"
                :total-visible="20"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <NewTargetDialog
        :showDialog="showNewTargetDialog"
        :processType="'new'"
        @dialogChange="(e) => (showNewTargetDialog = e)"
    ></NewTargetDialog>
  </div>

</template>

<script>
import ResultsTableView from "@/components/management/target/salesperson/results/ResultsTableView.vue";
import NewTargetDialog from "@/components/management/target/salesperson/dialogs/NewTargetDialog.vue";
import {mapActions, mapState} from "vuex";
import {formattedDate, formatTest} from "@/momentHelper";
export default {
  name: "Target-Results",
  components: {
    ResultsTableView,
    NewTargetDialog,
  },
  mounted() {
    this._fetchSalespersonTargetList();
  },
  computed: {
    ...mapState("target",["targetList"]),
    ...mapState("cart",["current"]),
    ...mapState("auth",["user"]),
  },
  data() {
    return {
      perPage: 10,
      currentPage:1,
      salespersonCode: null,
      salespersonName: null,
      dateRangeStart: null,
      dateRangeEnd: null,
      showNewTargetDialog: false,
    }
  },
  methods: {
    formattedDate,
    formatTest,
    ...mapActions("target",["fetchSalespersonTargetList"]),
    _fetchSalespersonTargetList() {
      this.fetchSalespersonTargetList({
        params: {},
        body: {},
      });
    },
    openNewTargetDialog() {

      this.showNewTargetDialog = true;
    },
  },
  // watch:{
  //   perPage: function (newVal) {
  //     newVal;
  //     this.currentPage = 1;
  //     this._fetchSalespersonTargetList();
  //   },
  //
  //   currentPage: function (newVal) {
  //     newVal;
  //     this._fetchSalespersonTargetList();
  //   }
  // }
}
</script>

<style scoped>

</style>